import { httpPost } from '@/services/api/http'
import { version, PARTNER } from '@/constants'

const headers = {
  'Client': 'WEB',
  'X-Partner': PARTNER,
  'X-App-Version': version,
}

export const apiGetNotifications = (groupIDs, limit = 20, offset = 0) =>
  httpPost({ route: 'api/v1/notifications', fields: { groupIDs, limit, offset }, headers })

export const apiPollNotifications = (groupIDs, lastVersion) =>
  httpPost({ route: 'api/v1/notifications/poll', fields: { groupIDs, lastVersion }, headers })
